<template>
  <div style="display: inline-block; min-width: 18px">

    <font-awesome-icon v-if="status === 'ERROR'"
                       icon="exclamation" transform="right-1" class="text-danger"/>
    <font-awesome-icon v-if="status === 'EDITED'"
                       icon="pen" transform="shrink-5 up-5 left-2 " class="text-success"/>
    <font-awesome-icon v-if="notification && isChat" :icon="['far', 'bell-ring']" class="px-1 fa-xl"
                       style="color: #F49536" transform="shrink-2"></font-awesome-icon>

  </div>


</template>

<script>

import SessionManager from "@/utils/SessionManager";
import Events from "@/utils/Events";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import ChatMessageInquiry from "@/server/com/silkplm/model/plm/chat/ChatMessageInquiry";

export default {
  name: "TabIcon",
  async beforeMount() {
    this.$onEvent(Events.unreadMessagesNotifications, (data) => {
      this.notification = data.notification;
      this.id = data.entityId;
    });
  },
  props: {
    status: {type: String, default: ""},
    tab: {default: null},
    entityId: {default: null},
  },
  computed: {
    isChat() {
      return ((this.tab?.detail?.config?.detailsClass === ChatMessageBase.getRemoteClass()
              || this.tab?.detail?.config?.detailsClass === ChatMessageInquiry.getRemoteClass())
          && this.id === this.entityId);
    }
  },
  data() {
    return {
      notification: {type: Boolean, default: false},
      id: {default: null}
    }
  }
}
</script>

<style scoped>

</style>